import { getPath } from '@/router/common'
const baseUrl = {
  title: '银行卡信息',
  path: 'bankPrepare'
}

export default [
  {
    path: getPath('PaymentMethod', baseUrl),
    name: 'PaymentMethod',
    component: () => import(/* webpackChunkName: "PaymentMethod" */ '@/views/bankPrepare/paymentMethod/index.vue'),
    meta: {
      title: '支付方式信息'
    }
  },
  {
    path: getPath('Index', baseUrl),
    name: 'bankPrepareIndex',
    component: () => import(/* webpackChunkName: "Index" */ '@/views/bankPrepare/index/index.vue'),
    meta: {
      title: '银行卡信息'
    }
  },
  {
    path: getPath('addOrEdit', baseUrl),
    name: 'BankPrepareAddOrEdit',
    component: () => import(/* webpackChunkName: "BankPrepareAddOrEdit" */ '@/views/bankPrepare/addOrEdit/index.vue'),
    meta: {
      title: '新增或修改银行信息'
    }
  },
  {
    path: getPath('CustomAccount', baseUrl),
    name: 'CustomAccount',
    component: () => import(/* webpackChunkName: "CustomAccount" */ '@/views/bankPrepare/customAccount/index.vue'),
    meta: {
      title: '自定义上缴账号'
    }
  },
  {
    path: getPath('addOrEditCustomAccount', baseUrl),
    name: 'addOrEditCustomAccount',
    component: () => import(/* webpackChunkName: "addOrEditCustomAccount" */ '@/views/bankPrepare/addOrEditCustomAccount/index.vue'),
    meta: {
      title: '新增或修改上缴账号'
    }
  },
  {
    path: getPath('paytypeaddOrEdit', baseUrl),
    name: 'paytypeaddOrEdit',
    component: () => import(/* webpackChunkName: "paytypeaddOrEdit" */ '@/views/bankPrepare/paytypeaddOrEdit/index.vue'),
    meta: {
      title: '新增或修改支付方式信息'
    }
  }
]
